enum ChildAnswerTypeEnum {
  Sex = "Sex",
  Birth = "Birth",
  Oib = "Oib",
  Age = "Age",
  Address = "Address",
}

export default ChildAnswerTypeEnum;
